module.exports = __webpack_public_path__ + "img/Group.1e62a070.png";